// Locale
const localeKey: string = 'locale';
export const getLocale = (): string | null => localStorage.getItem(localeKey);
export const setLocale = (locale: string) => localStorage.setItem(localeKey, locale);
